import React, { useState, useEffect } from 'react';
import { SolicitationView } from '../../../../models/SolicitationView';
import Parse from 'html-react-parser';
import "./index.css";
import SolicitationAttachmentService from '../../../../services/SolicitationAttachmentService/SolicitationAttachmentService';
import FastSolicitationService from '../../../../services/FastSolicitationService/FastSolicitationService';
import SolicitationService from '../../../../services/SolicitationService/SolicitationService';
import TextTools from '../../../../services/TextTools/TextTools';
import SideModal from '../../../../components/Layout/SideModal/SideModal';
import SolicitationDetailsRating from './SolicitationDetailsRating';
import SolicitationDetailsPropeties from './SolicitationDetailsPropeties';
import SolicitationDetailsAddAttachment from '../SolicitationDetails/SolicitationDetailsAddAttachment';
import SolicitationDetailsComments from './SolicitationDetailsComments';
import { useSelector } from 'react-redux';
import { UserState } from '../../../../store/reducers/userReducer';
import { RootState } from '../../../../store/index';
import DocumentView from '../../../../components/Generic/DocumentView';
import SolicitationDetailsReopen from './SolicitationDetailsReopen';
import { EndSolicitation } from "../../../../models/FastSolicitation";
import { Snackbar } from '@mui/material';
import MuiAlert, { AlertProps } from '@mui/material/Alert';
import LcLoading from '../../../../components/Generic/LcLoading';
import SolicitationDetailsClosing from './SolicitationDetailsClosing';
import SolicitationDetailsDynamicForm from './SolicitationDetailsDynamicForm';
import LcAccordion from '../../../../components/Generic/LcAccordion';
import StatusColorDisplay from '../../../../components/Generic/StatusColorDisplay';
import moment from 'moment';
import { spacing } from '@material-ui/system';
import Modal from '../../../../components/Dialog/Modal';
import LCFlexContainer from '../../../../components/Layout/LCFlexContainer';
import LCFlexItem from '../../../../components/Layout/LCFlexItem';

interface Props {
    visible: boolean
    header: string
    onClose: Function
    width?: string
    solicitation: SolicitationView,
    handleCloseReopen: Function
    loading?: boolean,
    tabMobile?: number,
    getSolicitationsType?: Function
}

type AlertColor = 'success' | 'info' | 'warning' | 'error';

const SolicitationDetails: React.FC<Props> = (props) => {
    const user = useSelector<RootState, UserState>(state => state.user);

    const [solicitation, setSolicitation] = useState<any>();
    const textTools = new TextTools();
    const solicitationAttachmentService = new SolicitationAttachmentService(props);
    const fastSolicitationService = new FastSolicitationService(props);
    const solicitationService = new SolicitationService(props);
    const [open, setOpen] = useState<boolean>(false);
    const [files, setFiles] = useState<any[]>([]);
    const [data, setData] = useState<string>("");
    const [attachment, setAttachment] = useState<any>([]);
    const [openAttachment, setOpenAttachment] = useState<boolean>(false);
    const [reopen, setReopen] = useState<boolean>(false);

    const [showNotification, setShowNotification] = useState<boolean>(false);
    const [severity, setSeverity] = useState<AlertColor>("info");
    const [message, setMessage] = useState<string>('')
    const [loadingClosing, setLoadingClosing] = useState<boolean>(false);
    const [mobileTab, setMobileTab] = useState<number>(props.tabMobile ? props.tabMobile : 1);
    const [loadingDetails, setLoadingDetails] = useState<boolean>(false);
    const [commentSize, setCommentSize] = useState<number>(0);
    const [solicitationGroup, setSolicitationGroup] = useState<string>('');
    const [enableDetailsButton, setEnableDetailsButton] = useState<boolean>(false);

    useEffect(() => {
        if (props.visible) {
            setSolicitation(props.solicitation);
            let firstInput = document.querySelector('.side-modal.visible .body input') as HTMLInputElement;
            firstInput && firstInput.focus();
        }
        else {
            closingClose();
            reopenClose();
            setSolicitation(undefined);
        }
    }, [props.visible]);

    const getSolicitationGroupList = async (businessAreaId: number) => {
        try {
            if (Number(props.solicitation.solicitationGroupId) !== 0) {
                var solicitationResponse = await solicitationService.getSolicitationGroupByUser(Number(user.id), businessAreaId);
                let nameGroupSolicitation = solicitationResponse.data.find(i => i.solicitationGroupId === props.solicitation.solicitationGroupId).description;
                const returnedTarget = { ...props.solicitation, nameGroupSolicitation }
                setSolicitation(returnedTarget)
            }
        }
        catch (error) {
            debugger;
        }
    };

    useEffect(() => {
        setCommentSize(0)
        setSolicitation((props.solicitation) ? props.solicitation : undefined);

        // debugger
        setEnableDetailsButton(textTools.cleanAllTags(props.solicitation.details).length > 2000);

        if (props.solicitation) {
            getSolicitationGroupList(Number(props.solicitation.idBusinessArea))
            if (props.solicitation.details == null) {
                async function getSolicitation() {
                    setLoadingDetails(true);

                    try {
                        const teste = await solicitationService.getSolicitationDetailById(props.solicitation.id);
                        setSolicitation(teste.data);
                    }
                    catch (error) {
                        debugger;
                    }

                    setLoadingDetails(false);
                }

                getSolicitation();
            }
        }
    }, [props.solicitation]);

    const getAttendant = () => {
        if (solicitation.attendant) return `Atendido por <b> ${solicitation.attendant} </b>`;
        return "";
    }

    const downloadAttachment = (attachment: any) => {
        solicitationAttachmentService.downloadAttachmentById(attachment);
    }

    const handleOk = (filesTemp: any[]) => {
        setFiles(files.concat(filesTemp));
        setOpen(false);
    }

    const handleClose = () => {
        setOpen(false);
    }

    const handleCloseAttachment = () => {
        setOpenAttachment(false);
    }

    const [closing, setClosing] = useState<boolean>(false);

    const reopenClose = () => setReopen(false);
    const closingClose = () => setClosing(false);

    const closeSolicitation = async () => {
        setLoadingClosing(true);
        setReopen(false);

        const comment = {
            solicitationId: props.solicitation.id
        };

        try {
            await fastSolicitationService.endSolicitation(comment as EndSolicitation);
            setMessage("Solicitação encerrada com sucesso");
            setSeverity('success');
            setShowNotification(true);
            solicitation.idStatus = 8;
            props.handleCloseReopen();
            setClosing(false);
            props.getSolicitationsType && props.getSolicitationsType();
        }
        catch (error) {
            console.warn(error);
        }

        setLoadingClosing(false);
    }

    const Alert = React.forwardRef<HTMLDivElement, AlertProps>(
        function Alert(props, ref,) {
            return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
        }
    );

    const handleClose_ = (event?: React.SyntheticEvent | Event, reason?: string) => {
        if (reason === 'clickaway') {
            return;
        }

        setShowNotification(false)
    };

    useEffect(() => {
        if (showNotification) {
            setTimeout(() => {
                setShowNotification(false)
            }, 3000);
        }
    }, [showNotification])

    const handleOpenClosing = () => {
        setClosing(!closing);
        setReopen(false);
    }

    const handleOpenReopen = () => {
        setReopen(!reopen);
        setClosing(false);
    }

    const handleCommentSize = (size: number) => {
        setCommentSize(size);
    }

    const [fixedHeader, setFixedHeader] = useState<boolean>(true);

    const getStyle = () => {
        const styleFixed = {
            position: "sticky",
            backgroundColor: "#E2E6F3",
            top: '0',
            zIndex: "100",
            borderBottom: "1px solid lightgrey",
        } as React.CSSProperties;

        return (fixedHeader == true) ? styleFixed : undefined;
    }

    const getPriority = (urgency: number): string => {
        const priorities: string[] = ["", "Normal", "Média", "Alta", "Crítica"];
        return priorities[urgency] || "";
    };

    const parseText = (text: string) => {
        var text_ = textTools.cleanCss(text);
        text_ = (text_.includes("<body")) ? text_.replace("<body", "<body style=\"background-color: initial;\"") : text_;
        text_ = text_.replaceAll("\r\n", "");
        var texto = Parse((text_ + ' '));
        var arr: any[] = [].slice.call(texto);

        arr = (texto instanceof Array) ? [].slice.call(texto) : [texto];

        return arr as JSX.Element[];
    }

    const [modalOpen, setModalOpen] = useState<boolean>(false);

    return (
        <div className={`side-modalDetails ${props.visible && 'visible'}`} style={{ width: props.visible ? (props.width || '35rem') : '' }}>
            {
                window.screen.width > 600
                    ? <>
                        <div className="header" style={getStyle()}>
                            <span style={{
                                display: '-webkit-box',
                                WebkitLineClamp: '5',
                                WebkitBoxOrient: 'vertical',
                                overflowWrap: 'break-word'
                            }}>{props.header}</span>
                            <div className="lciconlink">
                                <i className="link ppi ppi-x" onClick={() => props.onClose(false)} />
                            </div>
                        </div>

                        <Snackbar open={showNotification} anchorOrigin={{ vertical: 'top', horizontal: 'center' }} onClose={handleClose_}>
                            <Alert variant="filled" severity={severity} onClose={handleClose_} style={{ height: "48px" }}>
                                <div>
                                    <span className={(severity !== "success") ? "spanClass2" : "spanClass3"}>{message}</span>
                                </div>
                            </Alert>
                        </Snackbar>
                        <div className="body" id={"bodyModal"}>
                            {
                                solicitation &&
                                <>
                                    <div id={"divOrderAccordions"} className="divOrderAccordions">
                                        <LcLoading loading={loadingDetails} label="Carregando...">
                                            <div style={{ paddingTop: '15px' }}>
                                                {/* <p className='spanProprietiesNormal'> <strong>{item.subject}</strong>:</p> */}

                                                <p
                                                    className='spanProprietiesNormalAlt'
                                                    style={{
                                                        whiteSpace: "pre-line",
                                                        wordWrap: "break-word",
                                                        wordSpacing: "0.1rem",
                                                        maxHeight: '310px',
                                                        overflow: 'hidden',
                                                        // border: (enableDetailsButton) ? '1px gray solid' : "none",
                                                        padding: '5px',
                                                        borderRadius: '8px',
                                                        marginBottom: '10px',
                                                        overflowY: "visible",
                                                    }}>
                                                    {solicitation.details ? parseText(solicitation.details) : ""}
                                                </p>

                                                {
                                                    enableDetailsButton &&
                                                    <button className={'lc-button bg-info'} onClick={() => setModalOpen(true)}>Ver detalhes</button>
                                                }

                                                <Modal
                                                    title={"Detalhes"}
                                                    close={() => { setModalOpen(false); }}
                                                    visible={modalOpen}
                                                    width={"80%"}>
                                                    <p style={{ textAlign: "initial", width: "95%", maxHeight: "60vh", margin: "20px" }} className={"datails scrollable-v"}>{parseText(solicitation.details)}</p>
                                                    <div className="row end">
                                                        <button
                                                            style={{ margin: '10px' }}
                                                            className='lc-button bg-info'
                                                            id={'Fechar'}
                                                            onClick={() => {
                                                                setModalOpen(false);
                                                            }}
                                                            color="primary"
                                                        >
                                                            Fechar
                                                        </button>
                                                    </div>
                                                </Modal>
                                                <span className='spanProprietiesNormal'> {Parse(getAttendant())} </span>
                                            </div>
                                        </LcLoading>
                                        {
                                            solicitation.idStatus === 7 &&
                                            <div className="divOrderNewAttachmentButton" style={{ left: "30px" }}>
                                                <div style={{ width: '100%', marginBottom: '20px' }}>
                                                    <button type="button" className={"lc-button bg-info"} style={{ width: "100px", marginTop: '5px', marginRight: "5px" }} onClick={() => handleOpenClosing()}> Encerrar </button>
                                                    <button type="button" className={"lc-button bg-info"} style={{ width: "100px" }} onClick={() => handleOpenReopen()}> Reabrir </button>
                                                </div>
                                                <hr />
                                            </div>
                                        }
                                        <LcLoading loading={loadingClosing} label="Carregando...">
                                            <SolicitationDetailsReopen
                                                reopen={reopen}
                                                solicitation={solicitation}
                                                user={user}
                                                handleCloseReopen={props.handleCloseReopen}
                                                reopenClose={reopenClose}
                                                getSolicitationsType={props.getSolicitationsType}
                                            />
                                            <SolicitationDetailsClosing closing={closing} handleCloseSolicitation={closeSolicitation} />
                                            <SolicitationDetailsRating solicitation={solicitation} user={user} getSolicitationsType={props.getSolicitationsType} />
                                            <SolicitationDetailsPropeties solicitation={solicitation} />
                                            <SolicitationDetailsDynamicForm item={solicitation} />

                                            <div className='textBox'>
                                                <LcAccordion title={"Comentários (" + commentSize + ")"} visible={true} iconNormal={true}>
                                                    {
                                                        props.visible && <SolicitationDetailsComments
                                                            solicitation={solicitation}
                                                            files={files}
                                                            handleCommentSize={handleCommentSize}
                                                            attendant={false} />
                                                    }
                                                </LcAccordion>
                                            </div>
                                        </LcLoading>
                                    </div>
                                </>
                            }
                        </div>
                        <DocumentView
                            data={data}
                            downloadAttachment={downloadAttachment}
                            attachment={attachment}
                            handleCloseAttachment={handleCloseAttachment}
                            openAttachment={openAttachment} />
                        <SideModal header={"Anexar arquivo"} visible={open} onClose={() => setOpen(false)}>
                            <SolicitationDetailsAddAttachment handleOk={handleOk} handleClose={handleClose} />
                        </SideModal>
                    </>
                    : <>
                        <div className="headerMobile">
                            <span>Chamado {props.solicitation && props.solicitation.id}</span>
                            <div className="lciconlink">
                                <i className="link ppi ppi ppi-x" onClick={() => {
                                    setMobileTab(1)
                                    props.onClose(false)
                                }} />
                            </div>
                        </div>

                        <Snackbar open={showNotification} anchorOrigin={{ vertical: 'top', horizontal: 'center' }} onClose={handleClose_}>
                            <Alert variant="filled" severity={severity} onClose={handleClose_} style={{ height: "48px" }}>
                                <div>
                                    <span className={(severity !== "success") ? "spanClass2" : "spanClass3"}>{message}</span>
                                </div>
                            </Alert>
                        </Snackbar>

                        <div className="bodyMobile">
                            {
                                solicitation && mobileTab === 1 &&
                                <>
                                    <div>
                                        <p className='spanProprietiesBold'> {solicitation.subject}</p>
                                    </div>
                                    <hr />
                                    <div className="statusMobile">
                                        <p className='spanProprietiesNormal'>{Parse(solicitation.details)}</p>
                                    </div>
                                    <hr />
                                    <div className="statusMobile">
                                        <p className='spanProprietiesNormal'>Status do chamado</p>
                                        <StatusColorDisplay row={solicitation} type={"solicitation"} />
                                    </div>
                                    <hr />
                                    <div className="infosMobile">
                                        <div className='divInfos'>
                                            <label>Prioridade</label>
                                            <p>
                                                {getPriority(solicitation.urgency)}
                                            </p>
                                            {/* <TextField  value={getPriority(item.urgency)} 
                                                style={{border:'none',background: '#E1E4E7', borderRadius: '4px', color: '#2B304F !important'}}
                                                disabled={true} /> */}
                                        </div>
                                        <div className='divInfos'>
                                            <label>Aberto em</label>
                                            <p>
                                                <strong>{moment(solicitation.solicitationDate).format("DD/MM/YYYY")}</strong> &nbsp; às &nbsp; <strong>{moment(solicitation.solicitationDate).format("HH:MM")}</strong>

                                            </p>
                                        </div>
                                        <div className='divInfos'>
                                            <label>Solicitante</label>
                                            <p>
                                                {solicitation.nameUserRequester} / {solicitation.nameBusinessArea} - {solicitation.nameService}
                                            </p>
                                        </div>
                                    </div>
                                </>
                            }
                            {
                                solicitation && mobileTab === 2 &&
                                <div>
                                    <div className='textBox'>
                                        <SolicitationDetailsComments
                                            solicitation={solicitation}
                                            files={files}
                                            handleCommentSize={handleCommentSize}
                                            attendant={false}
                                        />

                                    </div>
                                </div>
                            }
                            {
                                solicitation && mobileTab === 3 &&
                                <div>
                                    <p className='spanProprietiesBold'>{solicitation.subject}</p>
                                    <hr />
                                    <div className="statusMobile">
                                        <p className='spanProprietiesNormal'>Status do chamado</p>
                                        <StatusColorDisplay row={solicitation} type={"solicitation"} />
                                    </div>
                                    <hr />
                                    <SolicitationDetailsRating solicitation={solicitation} user={user} getSolicitationsType={props.getSolicitationsType} />
                                </div>
                            }
                            {
                                solicitation &&
                                <div className="btnTabs">
                                    <button className='left' onClick={() => setMobileTab(1)} style={{ backgroundColor: mobileTab === 1 ? '#88B8FF' : "#B8CCEA" }}>Detalhes</button>
                                    <button onClick={() => setMobileTab(2)} style={{ backgroundColor: mobileTab === 2 ? '#88B8FF' : "#B8CCEA" }}>Comentários</button>
                                    <button disabled={(solicitation.idStatus !== 8)}
                                        onClick={() => setMobileTab(3)}
                                        style={{
                                            opacity: (solicitation.idStatus === 8) ? '1' : '0.3',
                                            backgroundColor: mobileTab === 3 ? '#88B8FF' : "#B8CCEA"
                                        }}
                                        className='right'
                                    >
                                        Avaliação
                                    </button>
                                </div>
                            }
                        </div>
                    </>
            }
        </div>
    );
};

export default SolicitationDetails;